import { Component, OnInit, OnDestroy } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {Roomlisting,RoomlistingService } from './roomlisting.services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
import { AlertService} from './../services/alert.service';



declare var jQuery: any;
interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  
  
  
}

let bigtos_pluugging = document.querySelector('bigtos');
let plugging = bigtos_pluugging ? bigtos_pluugging.innerHTML : "";

let hotemodel;



if(plugging.length)
{
    
   
    let jsonObject : any = JSON.parse(plugging)
    console.log("hotel:->"+JSON.stringify(jsonObject));
    
    if(jsonObject.hotel)
    {
	    hotemodel=true;
    }
    else
    {
	    hotemodel=false;
    }
}
console.log("hoteldata"+hotemodel);
let componentdata;
if(hotemodel)
{
   componentdata={templateUrl: './pg/hotel/roomlisting.component.html'}
}
else
{
   componentdata={template: '<div></div>'}

   
}
@Component(componentdata)

export class RoomlistingComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    public category;    
    public categorylist:Array<any>;
    public bookingdetail:Array<any>;
    public grand_total=0;    
    public roombookqty=0;
    BookingForm1: FormGroup;
    public checkindate;
	public checkoutdate;
    public showbtn=true;
    public loadingbtn=true;
    public params;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private slimLoadingBarService: SlimLoadingBarService,
	    private alertService: AlertService,
	    public fb1: FormBuilder,	    
	    private _pageService: RoomlistingService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: ''
                 
				  	}	
	      this.BookingForm1 = fb1.group({
      'checkin1': [
        '', // default value
        Validators.compose([Validators.required])
      ],
      'checkout1': [
        '',
        Validators.compose([Validators.required])
      ],
      'adult1': [
        '',
        Validators.compose([Validators.required])
      ],
      'child1': [
        '',
        Validators.compose([Validators.required])
      ]
    });  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	    this.slimLoadingBarService.start();
	    this.listingdata();
	    
	  //  this.loadingbtn=true;
	    if(this.shareService.getgrandtotal()!=undefined)
	    {
		    this.grand_total=Number(this.shareService.getgrandtotal());
	    }
	     
	  
		 let mainjs=this.shareService.getmainjs();
		 jQuery.getScript('./'+mainjs);
	
		
	}
	
	listingdata()
	{
		this._sub = this._route.params.subscribe(params => {
	  
	        
			let slug =params['slug'];
			this.category=slug;
			//let checkindate='2017-05-28';
			//let checkoutdate='2018-04-30';
			//let adultpersion='2';
			
			//let children='0';
			let bookingrow =this.shareService.getbooking();
			//if(bookingrow.length)
			//{
			window.scrollTo(0, 0);
			let checkindate;
			let checkoutdate;
			let adultpersion;
			let children;
			// console.log(this.shareService.getbooking());
			if(this.shareService.getbooking()!=undefined)
			{
				checkindate=bookingrow.checkin;
				checkoutdate=bookingrow.checkout;
				adultpersion=bookingrow.adult;
				children=bookingrow.child;
				
				
				//console.log('inside');
				
			}
				
			//}
			 if(checkindate==undefined)
			 {
				 checkindate=this.currentdate();
				 checkoutdate=this.nextdate();
				 //console.log('inside');
				 
				 
			 }
			this.checkindate=checkindate;
			this.checkoutdate=checkoutdate;
			
			 /// console.log("Umesh->"+checkindate);
				 
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);
			   			   
			   
			   this._pageService.getRoomlist(checkindate,checkoutdate,adultpersion,children).subscribe(
        data => {
           
                 //     
                  //console.log(JSON.stringify(data.data));  
                  this.grand_total=0;          
                  this.pagedata.title=data.menu.link_showing_name;
                  this.pagedata.description=data.menu.description;                 
                  if(data.menu.link_showing_name)
                 this._title.setTitle(data.menu.link_showing_name);
                  else
                  this._title.setTitle(data.menu.link_showing_name);                  
                  this.categorylist=data.category;
                  this.bookingdetail=data.bookingdetail;
                  this.shareService.setPaymentinfo(data.paymentInfo);
                  this.loadingbtn=false;
                  
                  
                  
                 
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);                               
               this.slimLoadingBarService.complete();
           
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			   
			   
			   
			   
			   		   
		});
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }
    public removeroomval(x,i)
    {
        var roombookqty=this.categorylist[i].rooms[x].roombookqty;
        if (roombookqty > 0) {
	    roombookqty=this.categorylist[i].rooms[x].roombookqty--;
	    this.categorylist[i].rooms[x].roombooking.pop(roombookqty);
	    var booking=this.categorylist[i].rooms[x];
          booking['roomqty']=roombookqty;
         
         this.categorylist[i].no_of_room=this.categorylist[i].no_of_room+1;
         
                   
         // this.bookingdetail.pop(booking);

	    
	    }
	    roombookqty=this.categorylist[i].rooms[x].roombookqty;
	    
	    if(roombookqty==0)
	    {
		    this.categorylist[i].rooms[x].showbtn=!this.categorylist[i].rooms[x].showbtn ;
		    
		    let roomid=this.categorylist[i].rooms[x].id;
		    let indexbooking=0;
		    for (let entry of this.bookingdetail)
		    {
			    if(roomid==entry.id)
			  {
				  // return i;
				   			//console.log("deleted "+indexbooking);
			
			       this.bookingdetail.splice(indexbooking,1);

				  
			  }	
			  indexbooking++;

		    }
		    
		    
		     
	    }
	    
	    
	     
	    
	    
	     //var i = 0;
	    // var removebooking_index;
	    
	    

	     this.updatebooking(x,i);
	    
	    
    }
     public updatebooking(x,i)
     {
           var grandtotal=0;
	      this.bookingdetail.forEach(function (entry, i) 
	    {
	       var totaladult=0;
	       var totalchildren=0;
	       var totalroomqty=0;
	       var totalprice=0;
	      
	        entry.roombooking.forEach(function (entry1, x)
		     {
		    
			   // entry.children=parseInt(entry.children)+parseInt(entry1.children);
			   			   
			   totaladult=totaladult+entry1.adult;	
			   totalchildren=totalchildren+entry1.children;
			   var price=0;	
			   
			   if(entry1.adult==2)
			   {
				  price=entry.fnlPrice_two_adult;
			   }
			   else
			   {
				    if(entry1.adult==1)
				   {
					  price=entry.fnlPrice_one_adult;
				   }
				   else
				   {
				       console.log("Price-> extra"+entry.fnlPrice_one_adult);
				      var extrapersionprice=Number((entry1.adult)-2)*Number(entry.extra_bad_price);
				      
					  price=Number(entry.fnlPrice_two_adult)+Number(extrapersionprice); 
					  
					  
				   }
			   }
			   
			 //  console.log("Price->"+price);

			   
			   totalprice=totalprice+Number(price);
			 // grandtotal=Number(grandtotal)+Number(totalprice);
			  
			  // grandtotal=Number(totalprice);
			   
			  // console.log("totalprice->"+totalprice);
			  
			   //console.log(grandtotal);
			   
			   	   
			    
		    });
		    
		    // console.log(entry.adult+'->'+entry1.adult);
		   entry.adult=totaladult;
		   entry.children=totalchildren;
		   entry.roomqty=entry.roombooking.length;
		   entry.totalprice=totalprice;	
		   
		   grandtotal=Number(grandtotal)+Number(totalprice);	    
		    
	    });
	    
	   
	    this.grand_total=grandtotal;
	    
     }
     public addroomval(x,i)
    {
	    //document.getElementById('rooms').value=1;
	    
	    var roombookqty=this.categorylist[i].rooms[x].roombookqty;	    
	    
	    
	    var totalrooms=this.categorylist[i].max_of_room;
	    var noofroom=this.categorylist[i].no_of_room;
	    var availabvleroom=totalrooms-noofroom;	  	    
	    if(noofroom > 0)
	    {
	    if (roombookqty < totalrooms) 
	    {
	     roombookqty=this.categorylist[i].rooms[x].roombookqty++;
	    //  if (roombookqty > 0) {
	    this.categorylist[i].no_of_room=this.categorylist[i].no_of_room-1;
	    
	   // }
	     
	     var obj ={
           'children':0,
           'adult':2
          }
	     this.categorylist[i].rooms[x].roombooking.push(obj);
	     }
	    }
	     
	     var roomid=this.categorylist[i].rooms[x].id;
	    /* for (let entry of this.bookingdetail)
	      {
			  					
			  if(roomid==entry.id)
			  {
				  		  				  
				  entry.roomqty=roombookqty+1;
				  console.log("Test::"+entry.roomqty);		
				  this.grand_total=this.grand_total+(entry.room_price*entry.roomqty);
			  }					
		 });*/
	      
	     
	     this.updatebooking(x,i);
	     
	     //this.categorylist[i].rooms[x].roombooking.forEach(function (entry, i) 
	    
	   
	   
	    
	     
	    
	  //  });
	    
	 
	    
	    
    }
    public onChange(event,x,i,type,x1) {
    console.log(event.target.value);
    var roomid=this.categorylist[i].rooms[x].id;
    
    this.bookingdetail.forEach(function (entry, i) {
			// console.log('%d: %s', i, value);
			 
			 if(roomid==entry.id)
			  {
				
				 if(type=='children')
				 {
								
					 //entry.children=event.target.value;
					 entry.roombooking[x1].children=parseInt(event.target.value);
      
				 }
				 else	
				 {
					 //entry.adult=event.target.value;
					 entry.roombooking[x1].adult=parseInt(event.target.value);					 	
					 		
				 }	
								 
				  
			  }	
			
			});    
        this.updatebooking(x,i); 
    
    }
    public addroom(event,x,i) {
   //alert('Open ' + item);
          var rooms=this.categorylist[i].rooms;
           
          this.categorylist[i].rooms[x].showbtn=!this.categorylist[i].rooms[x].showbtn ;
          var roomid=this.categorylist[i].rooms[x].id;
          
          var booking=this.categorylist[i].rooms[x];
          booking['roomqty']=1;
          booking['children']=0;
          booking['adult']=0;
          //var bookingmain=[booking];
         // var obj = { roomid : booking };
          
          this.bookingdetail.push(booking);
          
          // console.log(JSON.stringify(this.bookingdetail));
           //this.bookingdetail.pop(0);
           // console.log(JSON.stringify(this.bookingdetail));
            
          this.addroomval(x,i);
          
          
  }
   public booknow()
   {
	   this.shareService.setbookingdetail(this.bookingdetail);
	   this.shareService.setgrandtotal(this.grand_total);
	   
	   this._router.navigate(['./booking']);
	   
	   
	   
   }
   public roominfo(room)
   {
	   console.log(room);
	   this.shareService.setroominfo(room);
	   

	   this._router.navigate(['./r/'+room.slug]);
   }
   public removeitem(x)
   {
	   this.bookingdetail.splice(x,1);
	   this.updatebooking(0,0);
   }
    currentdate()
    {
	    var date = new Date();
		return ('0' + date.getDate()).slice(-2)+ '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();


    }
    nextdate()
    {
	   var date = new Date();
	   var day=Number(date.getDate())+1;
	  return ('0' +day).slice(-2)+ '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
    }
    
    
    BookingValidate1(): boolean {

  if (this.BookingForm1.valid) {
    return true;
  }
  let errorMsg = '';
  

  let field_checkin =document.querySelector('input[id="checkin1"]')['value'];  
  if (!field_checkin) {
    if (field_checkin.errors['required']) {
      errorMsg = 'Provide Select Check In Date.<br />';
    }
  }

  let field_checkout = document.querySelector('input[id="checkout1"]')['value']; ;
  if (!field_checkout) {
    if (field_checkout.errors['required']) {
      errorMsg = errorMsg+'Provide Select Check Out Date.<br />';
    }
  }
  
  
 if(errorMsg!="")
 {
    //alert(errorMsg);
    this.alertService.error(errorMsg);
    
  return false;
  }
  else
  {
    return true;
  }
}
    
    doBookingListing(event)
    {
	    //console.log("Testing1->"+document.querySelector('input[id="checkin1"]')['value']);
	     if (this.BookingValidate1()) {
    
            let checkin = document.querySelector('input[id="checkin1"]')['value'];
			let checkout = document.querySelector('input[id="checkout1"]')['value'];
			this.loadingbtn=true;     			
            this.params = {
                 
                  checkin: checkin,
                  checkout: checkout,
                  adult: "2",
                  child:"0"
                  
                };
                //console.log("umesh");
                this.shareService.setbooking(this.params);
                this._pageService.deletelisting();
                this.listingdata();
                
               // this._router.navigate(['./h/booking']);
                
                
             // this._router.navigate(['./h/booking']);
   // );
               
               
               
              
    //};
  }
    }
    
    
    
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/hotel/roomlisting.component.ts